module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/relatorios/relatorios.component.css
// module id = ./src/app/relatorios/relatorios.component.css
// module chunks = main